// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../public/images/award.png");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".red span {\n  border: 1px solid red;\n  border-radius: 50%;\n}\n#elselectFundOrCompany.el-input__inner {\n  width: 100px !important;\n  margin-right: -10px !important;\n  border-top-right-radius: 0px !important;\n  border-bottom-right-radius: 0px !important;\n}\n#elselectCompany.el-input__inner,\n#elselectFund.el-input__inner {\n  border-top-left-radius: 0px !important;\n  border-bottom-left-radius: 0px !important;\n}\n.main_bg_img {\n  display: flex;\n  background: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") center no-repeat;\n  background-size: 100% 100%;\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"red": "red",
	"elselectFundOrCompany": "elselectFundOrCompany",
	"el-input__inner": "el-input__inner",
	"elselectCompany": "elselectCompany",
	"elselectFund": "elselectFund",
	"main_bg_img": "main_bg_img"
};
module.exports = ___CSS_LOADER_EXPORT___;
